<div id="rfq-summary-items-page">
    <div class="row row-title">
        <p class="heading-h5-regular">Items</p>
        <div *ngIf="isActionEnabled()">
            <div class="field-info">
                <p class="paragraph-medium-regular">
                    Select items that you wish to purchase from the same vendor and click “Raise PO”.
                </p>
                <p class="paragraph-medium-regular">
                    Alternatively, you can click "Export as excel" to download the items table as an excel file. Keep
                    items that you want to purchase from the same vendor and delete the other items. Upload the excel by
                    clicking "Import as checked items" and this will help you check the items in the table below.
                </p>
            </div>
            <div class="btn-container">
                <!-- TODO: replace or fix 'app-botton', as disabled should technically disabled click, but only styling is getting apply -->
                <app-button class="padBtn large-button" tabindex="0" name="Raise PO" type="flat-button"
                    (click)="!(selection.length == 0 || !hasPOAccess) && handleRaisePO()" [disabled]="selection.length == 0 || !hasPOAccess" />
                <app-button class="padBtn large-button" name="Export Excel" (click)="handleExport()" />
                <app-button class="padBtn large-button" name="Import as Checked Items" (click)="handleImport()"/>
            </div>
        </div>
    </div>
    <app-item-selection-listing [statusData]="statusData" [selectionMode]="isActionEnabled()" [list]="list" [mpMmsInformation]="mpMmsInformation"
        (selected)="handleSelection($event)" [preselect]="selection" (allItemsHavePoChange)="updateAllItemsHavePO($event)" />
</div>